var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.787 5.117A1.501 1.501 0 0 1 27.5 6v12.5H38a1.5 1.5 0 0 1 1.213 2.383l-16 22A1.5 1.5 0 0 1 20.5 42V29.5H10a1.5 1.5 0 0 1-1.213-2.383zM12.945 26.5H22a1.5 1.5 0 0 1 1.5 1.5v9.387L35.055 21.5H26a1.5 1.5 0 0 1-1.5-1.5v-9.389z"
  })));
};
export default SvgBolt;